<template>
    <div class="d-pan">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="起点" prop="start">
                <!-- <el-select v-model="ruleForm.start" placeholder="请选择起点">
            <el-option label="救援点1" value="shanghai"></el-option>
            <el-option label="救援点2" value="beijing"></el-option>
          </el-select> -->
                <el-input placeholder="请在图上选点，左键结束" v-model="ruleForm.start">
                    <el-button @click="selectedMode = 'start'" slot="append" icon="el-icon-edit"></el-button>
                </el-input>
            </el-form-item>
            <el-form-item label="终点" prop="end">
                <!-- <el-select v-model="ruleForm.end" placeholder="请选择终点">
            <el-option label="受灾点1" value="shanghai"></el-option>
            <el-option label="受灾点2" value="beijing"></el-option>
          </el-select> -->
                <el-input placeholder="请在图上选点，左键结束" v-model="ruleForm.end">
                    <el-button @click="selectedMode = 'end'" slot="append" icon="el-icon-edit"></el-button>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">路径规划</el-button>
                <el-button @click="resetForm('ruleForm')">清空</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
var point_Start = undefined;
var point_End = undefined;
var entityCache = [];
import axios from 'axios';
const wkx = require('wellknown');
export default {
    data() {
        return {
            ruleForm: {
                start: "",
                end: "",
            },
            rules: {
                start: [{ required: true, message: "请选择起点", trigger: "change" }],
                end: [{ required: true, message: "请选择终点", trigger: "change" }],
            },
            selectedMode: "",
        };
    },
    mounted() {
        var $this = this;
        var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        handler.setInputAction(function (evt) {
            if ($this.selectedMode == "start") {
                //单机开始绘制
                var cartesian = $this.getCatesian3FromPX(evt.position);
                $this.ruleForm.start = cartesian;
                $this.selectedMode = "";
            }
            if ($this.selectedMode == "end") {
                //单机开始绘制
                var cartesian = $this.getCatesian3FromPX(evt.position);
                $this.ruleForm.end = cartesian;
                $this.selectedMode = "";
            }
        }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
        handler.setInputAction(function (evt) {
            if ($this.selectedMode == "start") {
                var cartesian = $this.getCatesian3FromPX(evt.endPosition);
                $this.ruleForm.start = cartesian;
            }
            if ($this.selectedMode == "end") {
                var cartesian = $this.getCatesian3FromPX(evt.endPosition);
                $this.ruleForm.end = cartesian;
            }
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    },
    beforeDestroy() {
        this.selectedMode = "";
        this.clear();
    },
    methods: {
        getCatesian3FromPX(px) {
            var $this = this;
            //var cartesian = viewer.scene.pickPosition(px);
            var cartesian;
            var ray = viewer.camera.getPickRay(px);
            cartesian = viewer.scene.globe.pick(ray, viewer.scene);
            if (cartesian) {
                if ($this.selectedMode == "start") {
                    if (!point_Start) {
                        point_Start = $this.createPoint(cartesian, "起点");
                    } else {
                        point_Start.position.setValue(cartesian);
                    }
                }
                if ($this.selectedMode == "end") {
                    if (!point_End) {
                        point_End = $this.createPoint(cartesian, "终点");
                    } else {
                        point_End.position.setValue(cartesian);
                    }
                }

                var position = Cesium.Cartographic.fromCartesian(cartesian); //new this.Cesium.Cartographic(-1.31968, 0.698874);
                var longitudeString = Cesium.Math.toDegrees(position.longitude);
                var latitudeString = Cesium.Math.toDegrees(position.latitude);
                return [longitudeString, latitudeString].toString();
            }

            return [].toString();
        },
        createPoint(cartesian, text) {
            var point = viewer.entities.add({
                position: cartesian,
                point: {
                    pixelSize: 10,
                    color: Cesium.Color.YELLOW,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                },
                label: {
                    text: text,
                    font: "18px sans-serif",
                    style: Cesium.LabelStyle.FILL,
                    outlineWidth: 1,
                    fillColor: Cesium.Color.WHITE,
                    showBackground: true,
                    backgroundColor: Cesium.Color.ORANGE.withAlpha(1),
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    // pixelOffset: new Cesium.Cartesian2(5.0, -20.0),
                },
            });
            entityCache.push(point);
            return point;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var points = [];
                    var A = axios.get(`http://127.0.0.1:9999/gis/transformAtoB?x=${this.ruleForm.start.split(',')[0]}&y=${this.ruleForm.start.split(',')[1]}&sridA=4326&sridB=3857`);
                    var B = axios.get(`http://127.0.0.1:9999/gis/transformAtoB?x=${this.ruleForm.end.split(',')[0]}&y=${this.ruleForm.end.split(',')[1]}&sridA=4326&sridB=3857`);
                    points.push(A);
                    points.push(B);
                    Promise.all(points)
                        .then((results) => {
                            console.log(results);

                            // 解析ST_ASEWKT格式数据
                            const geometryA = wkx.parse(results[0].data.data[0].st_asewkt);

                            // 解析ST_ASEWKT格式数据
                            const geometryB = wkx.parse(results[1].data.data[0].st_asewkt);

                            // 输出解析后的几何对象//coordinates
                            //console.log(geometry);

                            axios.get(`http://127.0.0.1:9999/gis/findAtoB?sX=${geometryA.coordinates[0]}&sY=${geometryA.coordinates[1]}&eX=${geometryB.coordinates[0]}&eY=${geometryB.coordinates[1]}`)
                                .then(res => {
                                    console.log(res);

                                    var data = res.data.data;
                                    var lin_arr = [];
                                    for (let i = 0, len = data.length; i < len; i++) {
                                        var st_asewkt = data[i].geom;
                                        const geometry = wkx.parse(st_asewkt);
                                        geometry.coordinates.forEach((coor) =>
                                            lin_arr.push(Cesium.Cartesian3.fromDegrees(coor[0], coor[1]))
                                        );
                                    }

                                    this.drawLine(lin_arr);

                                }).catch(err => {
                                    console.error(err);
                                });
                        })
                        .catch((error) => {
                            console.error('One or more promises rejected:', error);
                        });
                } else {
                    return false;
                }
            });
        },
        //[[],[],[]]
        drawLine(lin_arr) {
            var line = {
                polyline: {
                    clampToGround: true,
                    positions: lin_arr,
                    width: 10,
                    material: Cesium.Color.YELLOW,
                    // material: new LArk.LineFlowMaterial({
                    //   //动画线材质
                    //   color: Cesium.Color.AQUA.withAlpha(0.8),
                    //   duration: 5000, //时长，控制速度
                    //   url: require("../../assets/LinkPulse.png"),
                    // }),
                },
            };
            var line_enty = viewer.entities.add(line);
            viewer.zoomTo(line_enty);
            entityCache.push(line_enty);
            //this.addCar(car3Arr);
        },
        addCar(car3Arr) {
            var car_4 = viewer.entities.add({
                position: car3Arr[0],
                billboard: {
                    image: "data/img/marker/mark-blue.png",
                    scale: 0.5,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                },
                label: {
                    text: "救援物资车辆",
                    font: "14px sans-serif",
                    pixelOffset: new Cesium.Cartesian2(0.0, -60.0),
                    fillColor: Cesium.Color.YELLOW,
                    outlineColor: Cesium.Color.YELLOW,
                    outlineWidth: 2,
                    style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                },
            });
            var property_4_car = new Cesium.SampledPositionProperty();
            var time_4_car = 1; //移动的时长 ，秒
            var tempTime_4_car;
            tempTime_4_car = viewer.clock.currentTime; //飞行开始时间
            viewer.clock.currentTime = viewer.clock.startTime;
            viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
            viewer.clock.clockStep = Cesium.ClockStep.SYSTEM_CLOCK_MULTIPLIER;

            // 循环所有坐标数组，并逐渐添加下一个运动点
            car3Arr.forEach((pos) => {
                tempTime_4_car = Cesium.JulianDate.addSeconds(
                    tempTime_4_car,
                    time_4_car,
                    new Cesium.JulianDate()
                );
                property_4_car.addSample(tempTime_4_car, pos);
            });
            car_4.position = property_4_car;
            car_4.orientation = new Cesium.VelocityOrientationProperty(
                property_4_car
            );
            entityCache.push(car_4);
        },
        clear() {
            for (var i = 0; i < entityCache.length; i++) {
                viewer.entities.remove(entityCache[i]);
            }
            entityCache = [];
            point_Start = null;
            point_End = null;
        },
        resetForm(formName) {
            this.clear();
            this.$refs[formName].resetFields();
        },
    },
};
</script>
  
<style lang="scss" scoped></style>